import React from 'react';
import { Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import { Home, ArrowLeft } from 'lucide-react';

const NotFound = () => {
  return (
    <>
      <PageTitle 
        title="Página não encontrada" 
        description="A página que você está procurando não foi encontrada."
      />

      <div className="min-h-[70vh] flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <h1 className="text-9xl font-bold text-gray-200">404</h1>
          <h2 className="text-3xl font-bold text-gray-800 mt-4">Página não encontrada</h2>
          <p className="text-gray-600 mt-4 text-lg">
            A página que você está procurando não existe ou foi movida para outro endereço.
          </p>
          
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/" 
              className="flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
            >
              <Home size={18} />
              Voltar para a página inicial
            </Link>
            
            <button 
              onClick={() => window.history.back()} 
              className="flex items-center justify-center gap-2 px-6 py-3 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors"
            >
              <ArrowLeft size={18} />
              Voltar para a página anterior
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
